module.exports = __webpack_public_path__ + "fd097d98d8a185e29cea59dea6b7efab.jpg";